// Component imports
import copyToClipboard from './copyText';

let talkingPointsDirection = 'to';
let talkingPointsTopic = 'aces';
let selectedTalkingPoint = 'apha-talking-point-to-aces';

// DOM ELEMENTS
const copyTextButton = document.getElementById('apha-button-copy-text');
const talkingPointsButtons = document.querySelectorAll('.talking-points');
const directionButtons = document.querySelectorAll('.talking-points-direction');
const topicButtons = document.querySelectorAll('.talking-points-topic');
const talkingPoints = document.querySelectorAll('.apha-generated-talking-points');

/**
 * Changes the state of the talking points buttons
 * @param {MouseEvent} e click event
 */
const handleTalkingPointsButtonClick = (e) => {
  const clickedButton = e.target;
  if (e.target.classList.contains('talking-points-direction')) {
    talkingPointsDirection = clickedButton.dataset.direction;
    directionButtons.forEach((button) => {
      button.classList.remove('active');
    });
    clickedButton.classList.add('active');
  } else {
    talkingPointsTopic = clickedButton.dataset.topic;
    topicButtons.forEach((button) => {
      button.classList.remove('active');
    });
    clickedButton.classList.add('active');
  }
  selectedTalkingPoint = `apha-talking-point-${talkingPointsDirection}-${talkingPointsTopic}`;
  talkingPoints.forEach((talkingPoint) => {
    talkingPoint.classList.add('d-none');
  });
  document.getElementById(selectedTalkingPoint).classList.remove('d-none');
};

// Initialize popovers
$(() => {
  $('[data-toggle="popover"]').popover();
});

// EVENT LISTENERS
// copyTextButton.popover();
copyTextButton.addEventListener('click', () => {
  copyToClipboard(selectedTalkingPoint);
});
talkingPointsButtons.forEach((button) => {
  button.addEventListener('click', handleTalkingPointsButtonClick);
});
